import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { SignUpReason, useSignUpAttribution } from '../useSignUpAttribution/useSignUpAttribution'
import { isValidInitialVsId } from './isValidInitialVsId'

export type ReverificationAgent = {
  email: string
  firstName: string
  lastName: string
}

export const useReverificationSignUp = () => {
  const { signUpAttribution } = useSignUpAttribution()
  const { search } = useLocation()

  return useMemo(() => {
    const params = new URLSearchParams(search)
    const agent: ReverificationAgent = {
      email: params.get('email')?.trim() ?? '',
      firstName: params.get('first-name')?.trim() ?? '',
      lastName: params.get('last-name')?.trim() ?? ''
    }
    const initialVsId = params.get('initial-vs-id')?.trim() ?? ''
    const organisationId = params.get('organization-id')?.trim() ?? ''
    const reason = params.get('r') ?? signUpAttribution?.reason
    const hasAgentDetails = Boolean(agent.email && agent.firstName && agent.lastName)

    return {
      isReverificationSignUp:
        reason === SignUpReason.REVERIFICATION_FROM_VS &&
        hasAgentDetails &&
        isValidInitialVsId(initialVsId, organisationId),
      agent,
      initialVsId
    }
  }, [search, signUpAttribution?.reason])
}
